/* eslint-disable */
// @ts-nocheck
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Box,
  Typography,
  Button,
  Switch,
  Divider,
  Alert,
  Link,
  Chip,
  LinearProgress,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import StorageIcon from "@mui/icons-material/Storage";
import CloudIcon from "@mui/icons-material/Cloud";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { BORDER_RADIUS, BORDER_RADIUS_SM, BORDER_RADIUS_LG } from "../../theme/theme";

const ConnectorConfigModal = ({
  isConnectorModalOpen,
  setIsConnectorModalOpen,
  currentConnector,
  connectorAuthorization,
  connectorInputs,
  setConnectorInputs,
  originalConnectorInputs,
  isConnectorLoading,
  isEmailEnabled,
  isAutoRecordingEnabled,
  isOutlookContactsEnabled,
  autoRecordingSetupOpen,
  setAutoRecordingSetupOpen,
  storageStats,
  storageProvider,
  storageConfirmDialog,
  setStorageConfirmDialog,
  isSwitchingStorage,
  pendingStorageProvider,
  availableDrives,
  isFetchingDrives,
  selectedDriveId,
  setSelectedDriveId,
  isMigrationActionLoading,
  selectedOrganization,
  selectedOrgObj,
  organisationList,
  handleAuthorizeConnector,
  handleConnectMicrosoft365,
  handleDisconnectMicrosoft365,
  toggleEmailStatus,
  toggleAutoRecordingStatus,
  toggleOutlookContactsStatus,
  handleMigrationAction,
  handleStorageProviderClick,
  confirmAndStartMigration,
  fetchSharePointDrives,
  openSiteChangeDialog,
}: any) => {
  return (
    <Dialog
      open={isConnectorModalOpen}
      onClose={() => setIsConnectorModalOpen(false)}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: BORDER_RADIUS, pt: 2, px: 3, pb: 3 } }}
    >
      {currentConnector && (
        <>
          <DialogTitle
            sx={{ fontWeight: 700, fontSize: "1.125rem", pb: 0.5 }}
          >
            {connectorAuthorization[currentConnector?.id]?.isAuthorized
              ? `Manage ${currentConnector.name}`
              : `Connect ${currentConnector.name}`}
            <Typography
              component="div"
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 400, mt: 0.25 }}
            >
              {connectorAuthorization[currentConnector?.id]?.isAuthorized
                ? "Update your settings or credentials below."
                : "Enter your credentials to connect."}
            </Typography>
          </DialogTitle>

          <DialogContent sx={{ mt: 2 }}>
            <Box
              sx={{
                border: 1,
                borderColor: "grey.300",
                borderRadius: BORDER_RADIUS,
                p: 2.5,
              }}
            >
              {/* Special handling for AdviserLogic */}
              {currentConnector?.id === "adviserlogic" && (
                <>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 500 }}
                  >
                    Provide the details below
                  </Typography>
                  <Grid container spacing={1}>
                    {currentConnector.fields.map((field) => (
                      <Grid item xs={12} sm={6} key={field.name}>
                        <TextField
                          margin="normal"
                          label={field.label}
                          fullWidth
                          required
                          type={field.type}
                          value={connectorInputs[field.name] || ""}
                          onChange={(e) =>
                            setConnectorInputs((prev) => ({
                              ...prev,
                              [field.name]: e.target.value,
                            }))
                          }
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "10px",
                            },
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </>
              )}

              {/* M365 OAuth connect / disconnect UI */}
              {currentConnector?.id === "microsoft_365" &&
                (() => {
                  const ms365Record = (connectorAuthorization as any)
                    ?.microsoft_365;
                  const isConnected = ms365Record?.status === true;
                  const isNewModel = !!ms365Record?.orgTenantId;
                  const adminEmail =
                    ms365Record?.metadata?.email ||
                    ms365Record?.connectedAdminEmail;

                  // Warn if the connected Microsoft account's domain doesn't match
                  // the org's billing contact email domain — catches wrong-tenant connections
                  const selectedOrg = organisationList?.find(
                    (o: any) => o._id === selectedOrganization,
                  );
                  const orgEmailDomain = selectedOrg?.billingContactEmail
                    ?.split("@")[1]
                    ?.toLowerCase();
                  const connectedDomain = adminEmail
                    ?.split("@")[1]
                    ?.toLowerCase();
                  const domainMismatch = !!(
                    orgEmailDomain &&
                    connectedDomain &&
                    orgEmailDomain !== connectedDomain
                  );

                  return (
                    <Box sx={{ mb: 2 }}>
                      {isConnected && isNewModel ? (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              p: 2,
                              borderRadius: BORDER_RADIUS,
                              bgcolor: domainMismatch
                                ? "warning.light"
                                : "grey.50",
                              border: "1px solid",
                              borderColor: domainMismatch
                                ? "warning.main"
                                : "divider",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={1.5}
                            >
                              <Box
                                sx={{
                                  width: 10,
                                  height: 10,
                                  borderRadius: "50%",
                                  bgcolor: domainMismatch
                                    ? "warning.main"
                                    : "success.main",
                                  flexShrink: 0,
                                }}
                              />
                              <Box>
                                <Typography
                                  variant="subtitle2"
                                  fontWeight={600}
                                >
                                  Connected
                                </Typography>
                                {adminEmail && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {adminEmail}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                            <Button
                              size="small"
                              variant="outlined"
                              disabled={isConnectorLoading}
                              onClick={handleDisconnectMicrosoft365}
                              sx={{
                                bgcolor: "common.white",
                                borderColor: "divider",
                                color: "text.primary",
                                "&:hover": {
                                  bgcolor: "grey.50",
                                  borderColor: "grey.400",
                                },
                              }}
                            >
                              Disconnect
                            </Button>
                          </Box>
                          {domainMismatch && (
                            <Alert
                              severity="info"
                              sx={{
                                py: 0.5,
                                borderRadius: BORDER_RADIUS,
                              }}
                            >
                              The connected Microsoft account (
                              <strong>{connectedDomain}</strong>) has a
                              different domain to this organisation's
                              billing email (
                              <strong>{orgEmailDomain}</strong>). This is
                              fine if intentional — just double-check you
                              connected the correct Microsoft 365 tenant.
                            </Alert>
                          )}
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                            p: 3,
                            borderRadius: BORDER_RADIUS_SM,
                            border: "1px dashed",
                            borderColor: "grey.300",
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="text.secondary"
                          >
                            Connect your Microsoft 365 account to enable
                            email, Teams meetings, SharePoint storage, and
                            contact import. No Azure Portal setup
                            required.
                          </Typography>
                          <Button
                            variant="contained"
                            disabled={isConnectorLoading}
                            onClick={handleConnectMicrosoft365}
                            startIcon={
                              <img
                                src={currentConnector.icon}
                                alt="Microsoft"
                                style={{ width: 18, height: 18 }}
                              />
                            }
                          >
                            {isConnectorLoading
                              ? "Connecting..."
                              : "Connect Microsoft 365"}
                          </Button>
                          {isConnected &&
                            !isNewModel &&
                            !!ms365Record?.clientId && (
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Currently using legacy credentials.{" "}
                                <span
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                  onClick={handleConnectMicrosoft365}
                                >
                                  Upgrade to one-click connection
                                </span>
                              </Typography>
                            )}
                        </Box>
                      )}
                    </Box>
                  );
                })()}

              {/* M365 connected settings — shown after credentials section */}
              {currentConnector?.id === "microsoft_365" && (
                <React.Fragment>
                  {/* Section separator */}
                  <Box sx={{ mt: 3, mb: 2.5 }}>
                    <Divider>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          fontWeight: 600,
                          letterSpacing: "0.06em",
                          px: 1,
                        }}
                      >
                        Connected settings
                      </Typography>
                    </Divider>
                  </Box>

                  {/* Email */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 2 }}
                  >
                    <Box>
                      <Typography variant="subtitle2" fontWeight={600}>
                        Email integration
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                      >
                        Allow Prospo to send and read emails via Microsoft
                        365
                      </Typography>
                    </Box>
                    <Switch
                      checked={isEmailEnabled}
                      onChange={toggleEmailStatus}
                      color="primary"
                    />
                  </Box>
                  <Divider sx={{ mb: 2 }} />

                  {/* Outlook contact import */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 2 }}
                  >
                    <Box>
                      <Typography variant="subtitle2" fontWeight={600}>
                        Outlook contact import
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                      >
                        Allow users to import their personal Outlook
                        contacts into Prospo
                      </Typography>
                    </Box>
                    <Switch
                      checked={isOutlookContactsEnabled}
                      onChange={toggleOutlookContactsStatus}
                      color="primary"
                    />
                  </Box>
                  <Divider sx={{ mb: 2 }} />

                  {/* Auto-Recording */}
                  <Box sx={{ mb: 2 }}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <Box>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Typography
                            variant="subtitle2"
                            fontWeight={600}
                          >
                            Auto-record Teams meetings
                          </Typography>
                        </Box>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          Every Teams meeting created from Prospo will be
                          recorded automatically
                        </Typography>
                      </Box>
                      <Switch
                        checked={isAutoRecordingEnabled}
                        onChange={toggleAutoRecordingStatus}
                        color="primary"
                      />
                    </Box>
                  </Box>
                  <Divider sx={{ mb: 2 }} />

                  {/* File storage location */}
                  <Box sx={{ mt: 2, mb: 2 }}>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <Box>
                        <Typography variant="subtitle2" fontWeight={600}>
                          File storage location
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          Where Prospo stores uploaded files — Prospo's
                          servers or your SharePoint
                        </Typography>
                      </Box>
                      <Chip
                        icon={
                          storageProvider === "AZURE" ? (
                            <CloudIcon />
                          ) : (
                            <StorageIcon />
                          )
                        }
                        label={
                          storageProvider === "AZURE"
                            ? "Prospo Storage"
                            : "SharePoint"
                        }
                        color={
                          storageProvider === "AZURE"
                            ? "primary"
                            : "success"
                        }
                        size="small"
                      />
                    </Box>

                    {/* Help link for SharePoint integration — hidden, not needed */}
                    {/* <Alert severity="info" sx={{ mt: 2, mb: 1 }}>
                      <Typography variant="body2">
                        Need help setting up SharePoint as your storage
                        provider?{" "}
                        <Link
                          href="https://wiki.uiof.ai/share/ap3jwkd86s/p/share-point-integration-guide-7JDpf7OuUv"
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ fontWeight: 600 }}
                        >
                          Follow the SharePoint Integration Guide
                        </Link>
                      </Typography>
                    </Alert> */}

                    <Box
                      sx={{
                        mt: 2,
                        p: 2,
                        bgcolor: "#f8fafc",
                        borderRadius: BORDER_RADIUS,
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      {/* LIVE FILE STATS — hidden, confusing to users */}
                      {/* <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              p: 2,
                              bgcolor: "white",
                              borderRadius: 1,
                              border: "1px solid #e0e0e0",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="primary.main"
                              fontWeight="bold"
                            >
                              {storageStats?.azureFiles || 0}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                            >
                              Files in Prospo Storage
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              p: 2,
                              bgcolor: "white",
                              borderRadius: 1,
                              border: "1px solid #e0e0e0",
                              textAlign: "center",
                            }}
                          >
                            <Typography
                              variant="h5"
                              color="success.main"
                              fontWeight="bold"
                            >
                              {storageStats?.sharepointFiles || 0}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                            >
                              Files in SharePoint
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid> */}

                      {/* MIGRATION PROGRESS BAR (Only shows if active or paused) */}
                      {storageStats?.migrationState?.status ===
                        "IN_PROGRESS" ||
                      storageStats?.migrationState?.status ===
                        "PAUSED" ? (
                        <Box
                          sx={{
                            mb: 3,
                            p: 2,
                            bgcolor: "background.paper",
                            borderRadius: BORDER_RADIUS_SM,
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            mb={1}
                          >
                            <Typography
                              variant="body2"
                              fontWeight="bold"
                              color={
                                storageStats.migrationState.status ===
                                "PAUSED"
                                  ? "warning.main"
                                  : "primary.main"
                              }
                            >
                              {storageStats.migrationState.status ===
                              "PAUSED"
                                ? "⏸ Migration Paused"
                                : "🔄 Migration In Progress..."}
                              (
                              {storageStats.migrationState.direction ===
                              "TO_SHAREPOINT"
                                ? "To SharePoint"
                                : "To Prospo Storage"}
                              )
                            </Typography>
                            <Typography variant="body2" fontWeight="bold">
                              {storageStats.migrationState.completedFiles}{" "}
                              / {storageStats.migrationState.totalFiles}{" "}
                              Files
                            </Typography>
                          </Box>
                          <LinearProgress
                            variant="determinate"
                            value={
                              storageStats.migrationState.totalFiles > 0
                                ? (storageStats.migrationState
                                    .completedFiles /
                                    storageStats.migrationState
                                      .totalFiles) *
                                  100
                                : 0
                            }
                            sx={{ height: 8, borderRadius: BORDER_RADIUS_LG, mb: 2 }}
                            color={
                              storageStats.migrationState.status ===
                              "PAUSED"
                                ? "warning"
                                : "primary"
                            }
                          />

                          <Box display="flex" gap={2}>
                            {storageStats.migrationState.status ===
                            "IN_PROGRESS" ? (
                              <Button
                                variant="outlined"
                                color="warning"
                                size="small"
                                onClick={() =>
                                  handleMigrationAction("pause")
                                }
                                disabled={isMigrationActionLoading}
                              >
                                Pause Migration
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() =>
                                  handleMigrationAction("resume")
                                }
                                disabled={isMigrationActionLoading}
                              >
                                Resume Migration
                              </Button>
                            )}
                            {storageStats.migrationState.status ===
                              "PAUSED" && (
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={handleStorageProviderClick}
                                disabled={isMigrationActionLoading}
                              >
                                Reverse Direction
                              </Button>
                            )}
                          </Box>
                        </Box>
                      ) : (
                        <>
                          {/* STANDARD IDLE UI (Location Picker & Start Button) */}
                          {storageProvider === "SHAREPOINT" && (
                            <Box
                              sx={{
                                mb: 3,
                                p: 2,
                                bgcolor: "background.paper",
                                borderRadius: BORDER_RADIUS_SM,
                                border: "1px solid #e0e0e0",
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                sx={{ mb: 1 }}
                              >
                                Active Target SharePoint Site:
                              </Typography>
                              <Typography
                                variant="body1"
                                color="success.main"
                                sx={{ fontWeight: 600, mb: 1 }}
                              >
                                {selectedOrgObj?.storageSettings
                                  ?.sharepointSiteName ||
                                  "Default Root Site"}
                              </Typography>

                              {selectedOrgObj?.storageSettings
                                ?.sharepointWebUrl && (
                                <Link
                                  href={
                                    selectedOrgObj.storageSettings
                                      .sharepointWebUrl
                                  }
                                  target="_blank"
                                  variant="body2"
                                  sx={{ display: "block", mb: 2 }}
                                >
                                  Open SharePoint Folder ↗
                                </Link>
                              )}

                              {/* NEW: Simple button that opens the warning dialog */}
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={openSiteChangeDialog}
                                sx={{ mt: 1 }}
                              >
                                Change Target Site
                              </Button>
                            </Box>
                          )}

                          <Button
                            variant="contained"
                            color={
                              storageProvider === "AZURE"
                                ? "success"
                                : "primary"
                            }
                            onClick={handleStorageProviderClick}
                            startIcon={<StorageIcon />}
                            fullWidth
                            sx={{
                              color: "white",
                              "& .MuiButton-startIcon": {
                                color: "white",
                              },
                            }}
                          >
                            Migrate all files to{" "}
                            {storageProvider === "AZURE"
                              ? "SharePoint"
                              : "Prospo Storage"}
                          </Button>
                        </>
                      )}
                    </Box>
                  </Box>
                  <Divider sx={{ mb: 2 }} />
                </React.Fragment>
              )}

              {/* Credential fields */}
              {currentConnector?.fields &&
                currentConnector.fields.length > 0 && (
                  <>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 500,
                        mt:
                          currentConnector?.id === "microsoft_365"
                            ? 2
                            : 0,
                      }}
                    >
                      Provide the details below
                    </Typography>

                    {/* Help link for Microsoft 365 credentials */}
                    {currentConnector?.id === "microsoft_365" && (
                      <Alert severity="info" sx={{ mt: 2, mb: 1 }}>
                        <Typography variant="body2">
                          Need help finding your App ID, Tenant ID, and
                          Client Secret?{" "}
                          <Link
                            href="https://cognitivoconsulting.sharepoint.com/:w:/s/Prospo/IQDF6fC9XR-2TJQBaupfmO2MAXbkfVxXdkgTokFXa5YGCNk?e=CaALKp"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ fontWeight: 600 }}
                          >
                            Follow this guide
                          </Link>
                        </Typography>
                      </Alert>
                    )}

                    <Grid container spacing={1}>
                      {currentConnector.fields.map((field) => (
                        <Grid item xs={12} sm={6} key={field.name}>
                          <TextField
                            margin="normal"
                            label={field.label}
                            fullWidth
                            required
                            type={field.type}
                            value={connectorInputs[field.name] || ""}
                            placeholder={
                              field.type === "password" &&
                              connectorAuthorization[currentConnector?.id]
                                ?.isAuthorized
                                ? "Enter new value to update"
                                : ""
                            }
                            onChange={(e) =>
                              setConnectorInputs((prev) => ({
                                ...prev,
                                [field.name]: e.target.value,
                              }))
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                              },
                            }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
            </Box>
          </DialogContent>

          {currentConnector.fields.length > 0 && (
            <DialogActions sx={{ justifyContent: "center", mt: 1 }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setIsConnectorModalOpen(false)}
                disabled={isConnectorLoading}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAuthorizeConnector}
                disabled={
                  isConnectorLoading ||
                  // Basic check: Require all fields to be filled
                  !currentConnector.fields.every(
                    (field) => connectorInputs[field.name],
                  ) ||
                  // Change detection: If already authorized, disable if no inputs have changed
                  (connectorAuthorization[currentConnector?.id]
                    ?.isAuthorized &&
                    JSON.stringify(connectorInputs) ===
                      JSON.stringify(originalConnectorInputs))
                }
              >
                {isConnectorLoading
                  ? connectorAuthorization[currentConnector?.id]
                      ?.isAuthorized
                    ? "Updating..."
                    : "Authorizing..."
                  : connectorAuthorization[currentConnector?.id]
                        ?.isAuthorized
                    ? "Update"
                    : "Authorise"}
              </Button>
            </DialogActions>
          )}
        </>
      )}
    </Dialog>
  );
};

export default ConnectorConfigModal;
